import api, { MULTIPART_CONFIG } from '../../shared/api/client';
import { API_ROUTES } from '../../shared/api/routes';

export const inventoryApi = {
  getTags: (params) => api.get(API_ROUTES.rfid.tags, { params }),
  importTags: (formData) => api.post(API_ROUTES.rfid.import, formData, MULTIPART_CONFIG),
  previewImport: (formData) => api.post(API_ROUTES.rfid.importPreview, formData, MULTIPART_CONFIG),
  commitImport: (data) => api.post(API_ROUTES.rfid.importCommit, data),
  getPackets: (params) => api.get(API_ROUTES.rfid.packets, { params }),
  createBatch: (data = {}) => {
    const payload = data.batchId ? { ...data, batchId: data.batchId } : data;
    return api.post(API_ROUTES.rfid.batches, payload);
  },
  getBatches: (params) => api.get(API_ROUTES.rfid.batches, { params }),
  linkTagsToBatch: (batchId, data = {}) =>
    api.post(API_ROUTES.rfid.batchLink(batchId), {
      ...data,
      batchId,
    }),
  allocateBatch: (batchId, data) => api.post(API_ROUTES.rfid.allocate, { ...data, batchId }),
  previewAllocation: (data) => api.post(API_ROUTES.rfid.allocatePreview, data),
  allocatePackets: (data) => api.post(API_ROUTES.rfid.allocate, data),
  assignTag: (tagId, data) => api.post(API_ROUTES.rfid.assign, { tagId, ...data }),
  unassignTag: (tagId, params) => api.delete(API_ROUTES.rfid.unassign(tagId), { params }),
  reassignTag: (tagId, data) => api.post(API_ROUTES.rfid.reassign, { tagId, ...data }),
  replaceTag: (data) => api.post(API_ROUTES.rfid.replace, data),
  changeTagStatus: (tagId, data) => api.patch(API_ROUTES.rfid.status(tagId), data),
  getAvailableTagsForSociety: (societyId) =>
    api.get(API_ROUTES.rfid.available, {
      params: { societyId, limit: 100 },
    }),
  getStats: (params) => api.get(API_ROUTES.rfid.stats, { params }),
  getAvailable: (params) => api.get(API_ROUTES.rfid.available, { params }),
  createTags: (data) => api.post(API_ROUTES.rfid.tags, data),
  bulkCreate: (data) => api.post(API_ROUTES.rfid.bulkCreate, data),
};
